import { o as o_util } from "../chunks/common-namespaces-client-DXKc2YAH.mjs";
const event = o_util.event ?? {};
const delegate = event.delegate;
const stop = event.stop;
const undelegate = event.undelegate;
const whichTransitionEndEvent = event.whichTransitionEndEvent;
export {
  delegate,
  event,
  stop,
  undelegate,
  whichTransitionEndEvent
};
/*                                     */
